import { render, staticRenderFns } from "./InfoImg.vue?vue&type=template&id=170e9da0&scoped=true&"
import script from "./InfoImg.vue?vue&type=script&lang=js&"
export * from "./InfoImg.vue?vue&type=script&lang=js&"
import style0 from "./InfoImg.vue?vue&type=style&index=0&id=170e9da0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "170e9da0",
  null
  
)

export default component.exports